import moment from 'moment';
import { computeEventStatus } from './eventStatus';
import { toJsDate } from './dateUtils';

/**
 * Format currency in Turkish Lira
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '-';
  return amount.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
};

/**
 * Format date using moment
 */
export const formatDate = (date, format = 'LL') => {
  const d = toJsDate(date);
  if (!d) return '';
  return moment(d).format(format);
};

/**
 * Format date and time
 */
export const formatDateTime = (date, dateFormat = 'DD/MM/YY', timeFormat = 'LT') => {
  const d = toJsDate(date);
  if (!d) return '';
  return `${moment(d).format(dateFormat)} - ${moment(d).format(timeFormat)}`;
};

/**
 * Generate a random ticket ID
 */
export const generateTicketID = () => {
  return Math.random()
    .toString(36)
    .replace(/[^a-z0-9]+/g, '')
    .substring(0, 8)
    .toUpperCase();
};

/**
 * Calculate total sessions from event sessions array
 */
export const calculateEventSessionsLength = (sessions) => {
  if (!sessions || !Array.isArray(sessions)) return 0;
  let totalSessions = 0;
  sessions.forEach((session) => {
    totalSessions += session.times ? session.times.length : 0;
  });
  return totalSessions;
};

/** @deprecated computeEventStatus — show/detay icin */
export const getEventStatus = (event) => {
  const s = computeEventStatus(event);
  return {
    status: s.key,
    label: s.label,
    color: s.bgColor,
  };
};

const formattingUtils = {
  formatCurrency,
  formatDate,
  formatDateTime,
  generateTicketID,
  calculateEventSessionsLength,
  getEventStatus,
};

export default formattingUtils;
